import { create } from 'zustand'
import { Lang, Group } from '../app-const';

const useLanguage = create((set) => ({
    lang: "EN",
    langCode: Lang.EN,
    group: Group.ENV,
    setLanguage: (lang) => set((state) => ({
        ...state, 
        lang: lang,
        langCode: lang === "EN" ? Lang.EN : Lang.VN,
    })),
    setGroup: (group) => set((state) => ({
        ...state, 
        group: group,
    })),
}))

export default useLanguage;
